(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jakes-retailer-finder"] && !Shopify.designMode) return;
  try {
    (function(){
  function init(){
    var root=document.getElementById('jakesRetailerFinder');
    if(!root||root.dataset.ready)return;
    root.dataset.ready='true';
    var input=root.querySelector('#jrf-query'),state=root.querySelector('#jrf-state'),status=root.querySelector('#jrf-status'),more=root.querySelector('.jrf__more'),empty=root.querySelector('.jrf__empty');
    var cards=Array.from(root.querySelectorAll('.jrf__card')),limit=12,matches=cards;
    var states={il:'illinois',mi:'michigan',mn:'minnesota',nd:'north dakota',wi:'wisconsin'};
    function normalize(s){return s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'').replace(/[’']/g,'').replace(/&/g,' and ').replace(/[^a-z0-9]+/g,' ').trim();}
    var records=cards.map(function(card){return {card:card,state:card.dataset.state.toLowerCase(),text:normalize(card.textContent+' '+states[card.dataset.state.toLowerCase()])};});
    function paint(){
      var count=matches.length,visible=matches.slice(0,limit);
      cards.forEach(function(card){card.hidden=visible.indexOf(card)<0;});
      empty.hidden=count!==0;
      more.hidden=count<=limit;
      more.textContent='Show more stores ('+Math.max(0,count-limit)+' remaining)';
      var q=input.value.trim(),chosen=state.options[state.selectedIndex].text;
      status.textContent='Showing '+Math.min(limit,count)+' of '+count+' listed '+(count===1?'retailer':'retailers')+(q?' matching “'+q+'”':'')+(state.value?' in '+chosen:'')+'.';
    }
    function filter(){
      var terms=normalize(input.value).split(' ').filter(Boolean),selected=state.value.toLowerCase();
      matches=records.filter(function(r){return (!selected||r.state===selected)&&terms.every(function(t){return r.text.indexOf(t)!==-1;});}).map(function(r){return r.card;});
      limit=12;paint();
    }
    root.querySelector('.jrf__form').addEventListener('submit',function(e){e.preventDefault();filter();});
    input.addEventListener('input',filter);
    state.addEventListener('change',filter);
    root.querySelector('.jrf__clear').addEventListener('click',function(){input.value='';state.value='';filter();input.focus();});
    root.querySelectorAll('.jrf__quick button').forEach(function(button){button.addEventListener('click',function(){input.value=button.textContent;state.value='';filter();});});
    more.addEventListener('click',function(){var next=matches[limit];limit+=12;paint();if(next){next.tabIndex=-1;next.focus({preventScroll:true});}});
    paint();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

})();
